import { render } from "./FilterItemPrice.vue?vue&type=template&id=f3b5f48c&scoped=true"
import script from "./FilterItemPrice.vue?vue&type=script&lang=js"
export * from "./FilterItemPrice.vue?vue&type=script&lang=js"

import "./FilterItemPrice.vue?vue&type=style&index=0&id=f3b5f48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b5f48c"]])

export default __exports__